import React from "react";
import withStyles from '@mui/styles/withStyles';
import Coupons from "../coupons";
import MyCoupons from "../coupons-my";
import Achievements from "../achievements";

const styles = (theme) => ({
  root: {},
});

const routeViews = {
  achievements: Achievements,
  coupons: Coupons,
  "my-coupons":MyCoupons,
};

const PointsRouteView = ({ routeName }) => {
  const RouteView = routeViews[routeName];
  if (RouteView) {
    return <RouteView />;
  }
  throw Error("Route not found");
};

export default withStyles(styles)(PointsRouteView);
